
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/privacy",
      function () {
        return require("private-next-pages/legal/privacy.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/privacy"])
      });
    }
  